// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M44P","type":"styles_type__szuHP","choices":"styles_choices__2bUY_"};